<div class="language-distribution-progress-bar">
    <!-- Detected Languages Section -->
    <div class="mb-5">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="mb-0 text-bold">Detected languages</span>
            <span class="text-muted">{{ totalDetectedLanguages() }} different detected languages across {{ totalPagesWithTags() }} pages ({{ totalPagesWithoutTags() }} pages undetected)</span>
        </div>

        <!-- Detected Languages Progress bar -->
        <ngb-progressbar-stacked class="mb-4">
            <ngb-progressbar
                *ngFor="let entry of detectedLanguageEntries(); let i = index"
                [value]="entry.percentage"
                [style.background-color]="getLanguageColor(i)"
                [ngbTooltip]="(entry.language | languageDisplay) + ': ' + entry.count + (entry.count === 1 ? ' page' : ' pages') + ' (' + entry.percentage.toFixed(1) + '%)'"
                [placement]="'top'">
                <span class="text-white fw-bold d-flex align-items-center justify-content-center h-100" *ngIf="entry.percentage > 5">
                    {{ entry.count }}
                </span>
            </ngb-progressbar>
        </ngb-progressbar-stacked>

        <div class="languages-legend">
            <div *ngFor="let entry of detectedLanguageEntries(); let i = index" class="legend-item">
                <div class="legend-indicator" [style.background-color]="getLanguageColor(i)"></div>
                <span class="legend-label">
                    <strong>{{ entry.language | languageDisplay }}</strong>
                    <span class="legend-count">{{ entry.count }} {{ entry.count === 1 ? 'page' : 'pages' }}</span>
                </span>
            </div>
        </div>
    </div>

    <!-- Declared Languages Section -->
    <div class="mb-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="mb-0 text-bold">Declared languages</span>
            <span class="text-muted">{{ totalUniqueDeclaredLanguages() }} different declared languages across {{ totalPages() }} pages</span>
        </div>

        <!-- Declared Languages Progress bar -->
        <ngb-progressbar-stacked class="mb-4">
            <ngb-progressbar
                *ngFor="let entry of declaredLanguageEntries(); let i = index"
                [value]="entry.percentage"
                [style.background-color]="entry.language === '' ? '#6c757d' : getLanguageColor(i)"
                [ngbTooltip]="(entry.language === '' ? 'Not Declared' : (entry.language | languageDisplay)) + ': ' + entry.count + (entry.count === 1 ? ' page' : ' pages') + ' (' + entry.percentage.toFixed(1) + '%)'"
                [placement]="'top'">
                <span class="text-white fw-bold d-flex align-items-center justify-content-center h-100" *ngIf="entry.percentage > 5">
                    {{ entry.count }}
                </span>
            </ngb-progressbar>
        </ngb-progressbar-stacked>

        <div class="languages-legend">
            <div *ngFor="let entry of declaredLanguageEntries(); let i = index" class="legend-item">
                <div class="legend-indicator" [style.background-color]="entry.language === '' ? '#6c757d' : getLanguageColor(i)"></div>
                <span class="legend-label">
                    @if (entry.language === '') {
                        <strong>Not Declared</strong>
                    } @else {
                        <strong>{{ entry.language | languageDisplay }}</strong>
                    }
                        <span class="legend-count">{{ entry.count }} {{ entry.count === 1 ? 'page' : 'pages' }}</span>
                </span>
            </div>
        </div>
    </div>

    <!-- No data state -->
    <div *ngIf="detectedLanguageEntries().length === 0 && declaredLanguageEntries().length === 0"
         class="text-center text-muted py-4">
        <span>No language data available</span>
    </div>
</div>
